import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../component/header'; // તમારા હેડરનો સાચો પાથ સેટ કરો

const FacebookViewer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    
    // પાછલા પેજ પરથી મોકલેલો ડેટા મેળવો
    const { fbUrl, userName } = location.state || {};

    useEffect(() => {
        // જો URL કે નામ ન હોય તો પાછા મોકલી દો
        if (!fbUrl) {
            navigate(-1);
        }
    }, [fbUrl, navigate]);

    // જો URL માં http કે https ન હોય તો ઉમેરો
    const formattedUrl = fbUrl?.startsWith('http') ? fbUrl : `https://${fbUrl}`;

    return (
        <div className="fb-viewer-container">
            {/* હેડરમાં યુઝરનું નામ દેખાડવા માટે */}
            <div className="header-wrapper shadow-sm">
                <Header title={`${userName || 'Profile'}`} />
            </div>

            <div className="iframe-wrapper">
                <iframe 
                    src={formattedUrl} 
                    title="Facebook Profile Viewer"
                    className="fb-iframe"
                    sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                    // ફેસબુક Iframe બ્લોક કરે છે, તેથી આ કદાચ ન ખુલે.
                ></iframe>
            </div>

            <style jsx>{`
             .header-wrapper { background: white; padding: 0 24px; position: sticky; top: 0; z-index: 50; }
                .fb-viewer-container {
                    width: 100%;
                    height: 100vh;
                    display: flex;
                    flex-direction: column;
                    background: #f1f5f9;
                }
                .header-wrapper {
                    background: white;
                    position: sticky;
                    top: 0;
                    z-index: 50;
                }
                .iframe-wrapper {
                    flex: 1;
                    width: 100%;
                    height: 100%;
                    padding: 0;
                    margin: 0;
                }
                .fb-iframe {
                    width: 100%;
                    height: 100%;
                    border: none;
                }
            `}</style>
        </div>
    );
};

export default FacebookViewer;